
          import p from "/home/nathan/goalert/web/src/app/public/logos/black/goalert-logo-scaled@2.webp"
          const prefixPath = pathPrefix + "/static/" + p
          export default prefixPath
        